export const getDate = (date) => {
    return new Date(
        new Date(date).toISOString().slice(0, -1)
    ).toDateString()
}